//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
export default {
  name: 'notfound',
  data() {
    return {
      langstxtObject: {
        zh_CN: {
          title: '温馨提示',
          desc: '页面不存在您来到了没有游戏的荒野'
        },
        en_US: {
          title: 'Tips',
          desc: 'The page does not exist You have come to a wilderness without games'
        },
        hi_IN: {
          title: 'टिप्स',
          desc: 'पृष्ठ मौजूद नहीं है आप बिना खेलों के जंगल में आ गए हैं'
        }
      },
      langstxt: {}
    }
  },
  computed: {
    ...mapState({
      errorMsg: state => state.errorMsg
    })
  },
  mounted() {
    this.langstxt = this.langstxtObject[this.$store.state.langs.keys]
    if (this.$route.query.err) this.langstxt.desc = this.$route.query.err
  },
  destroyed() {

  }
}



// WEBPACK FOOTER //
// ./src/common/notfound/404.vue